import cx from "classnames";
import { useTranslation } from "next-i18next";
import { ReactNode } from "react";

import { ButtonClose } from "@/components/elements/ButtonClose";
import { DialogBgClose } from "@/components/elements/DialogBgClose";
import { Text } from "@/components/elements/Text";
import { DialogSize, DialogTheme } from "@/hooks/useDialog";

import styles from "./styles.module.css";

export type ViewProps = {
  title?: string;
  dismissDialog: () => void;
  dialogSize: DialogSize;
  dialogTheme?: DialogTheme;
  children: ReactNode;
};

export const View = ({
  title,
  dismissDialog,
  children,
  dialogSize,
  dialogTheme,
}: ViewProps) => {
  const { t } = useTranslation();
  const closeCta = t("close_CTA");
  const isNewsletter = dialogTheme === "newsletter";

  return (
    <div
      className={cx(
        styles.container,
        { [styles._missingTitle]: !title },
        styles[dialogSize]
      )}
    >
      {!isNewsletter && (
        <DialogBgClose className={styles.bg} onClick={dismissDialog} />
      )}
      <div
        className={cx(styles.dialog, { [styles.newsletter]: isNewsletter })}
        id="dialog"
      >
        <div className={cx(styles.inner, styles[dialogTheme])}>
          <div className={styles.header}>
            {title && <Text>{title}</Text>}
            <ButtonClose
              className={styles.closeButton}
              onClick={dismissDialog}
              label={closeCta}
            />
          </div>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};
